import { createContext } from "react";

export interface CheckTableType {
  identifier: string;
  page: number;
  sortingType: string;
}

interface InitialStateType {
  checkOpenTableState: CheckTableType;
  checkOpenTableSetState: React.Dispatch<React.SetStateAction<CheckTableType>>;
}

const checkOpenTableContext = createContext<InitialStateType[]>([]);

export default checkOpenTableContext;
